import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { City } from '../../../../../shared/models/response/address/city';
import { District } from '../../../../../shared/models/response/address/district';
import { Street } from '../../../../../shared/models/response/address/street';
import { Constant } from '../../../../../shared/common/constant';
import { DateUtils } from '../../../../../shared/common/date-utils';
import { Observable } from 'rxjs';
import { Postcode } from '../../../../../shared/models/response/postcode';
import { PostcodeService } from '../../../../../shared/services/postcode.service';
import { map, mergeMap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { SearchRequest } from '../../../../../shared/models/request/search-request';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { StringUtils } from '../../../../../shared/common/string-utils';

@Component({
  selector: 'ngx-prospect-list-filter-callbackdate',
  templateUrl: './prospect-list-filter-callbackdate.component.html',
  styleUrls: ['./prospect-list-filter-callbackdate.component.scss'],
})
export class ProspectListFilterCallbackdateComponent implements OnInit {
  @Input() districts: District[];
  @Input() districtId: number;
  @Input() streets: Street[];
  @Input() streetId: number;
  @Input() cities: City[];
  @Input() cityId: number;
  @Input() total: number;
  @Input() farm: string;
  @Input() zone: string;
  @Output() onSuburbChange = new EventEmitter();
  @Output() onStreetChange = new EventEmitter();
  @Output() onCityChange = new EventEmitter();
  @Output() onAddNewProspect = new EventEmitter();
  @Output() onOpenShortcut = new EventEmitter();
  @Output() onBedChange = new EventEmitter();
  @Output() onBathChange = new EventEmitter();
  @Output() onCarChange = new EventEmitter();
  @Output() onSearch = new EventEmitter();
  @Output() onYearChange = new EventEmitter();
  @Output() onMonthChange = new EventEmitter();
  @Output() onDayChange = new EventEmitter();

  propertyTypes = Constant.PROPERTY_TYPE;
  bedValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  years: number[];
  months = DateUtils.MONTHS;
  days: number[];
  @Input() selectedYear: number;
  @Input() selectedMonth: number;
  @Input() selectedDay: number;
  @Input() postcode: number;
  @Output() onSearchByPostcode = new EventEmitter();
  filterPostcode$: Observable<Postcode[]>;
  filterByPostcode = false;

  constructor(private postcodeService: PostcodeService,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.years = [];
    for (let i = 2000; i <= 3000; i++) {
      this.years.push(i);
    }
    if (this.selectedMonth) {
      this.days = [];
      const firstDay = 1;
      const endDay = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
      for (let i = firstDay; i < endDay; i++) {
        this.days.push(i);
      }
    }
    this.filterPostcode$ = new Observable((observer: any) => {
      observer.next(this.postcode);
    }).pipe(
      map((query: string) => {
        this.postcode = Number(query);
        this.searchSuburbByPostcode();
        return null;
      }),
    );
  }

  onSuburbSelectChange() {
    this.onSuburbChange.emit(isNaN(Number(this.districtId)) ? undefined : Number(this.districtId));
  }

  onStreetSelectChange() {
    this.onStreetChange.emit(isNaN(Number(this.streetId)) ? undefined : Number(this.streetId));
  }

  onCitySelectChange() {
    this.onCityChange.emit(isNaN(Number(this.cityId)) ? undefined : Number(this.cityId));
  }

  onYearSelectChange() {
    this.onYearChange.emit(this.selectedYear);
  }

  onMonthSelectChange() {
    // const startDay = DateUtils.getFirstDayOfMonth(this.selectedMonth - 1, this.selectedYear).date();
    // const endDay = DateUtils.getLastDayOfMonth(this.selectedMonth - 1, this.selectedYear).date();
    // this.days = [];
    // for (let i = startDay; i <= endDay; i++) {
    //   this.days.push(i);
    // }
    // this.onMonthChange.emit(this.selectedMonth);
    this.selectedDay = undefined;
    this.days = [];
    const startDay = 1;
    const endDay = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
    for (let i = startDay; i <= endDay; i++) {
      this.days.push(i);
    }
    this.onMonthChange.emit(this.selectedMonth);
  }

  onDaySelectChange() {
    this.onDayChange.emit(this.selectedDay);
  }

  // =======
  keepOrder(a, b) {
    return 1;
  }

  initPurchaseDate() {
    if (this.selectedMonth) {
      const year = new Date().getFullYear();
      this.days = [];
      const firstDay = 1;
      const endDay = new Date(year, this.selectedMonth, 0).getDate();
      for (let i = firstDay; i < endDay; i++) {
        this.days.push(i);
      }
    }
  }

  searchPostcode(keyword: string): Observable<Postcode[]> {
    const searchRequest = new SearchRequest();
    searchRequest.conditions = [];
    searchRequest.orders = [];
    searchRequest.conditions.push(
      {
        left: 'code',
        middle: '=',
        right: keyword,
      },
    );
    searchRequest.orders.push(
      {
        left: 'code',
        right: 'asc'
      }
    );
    searchRequest.offset = 0;
    searchRequest.limit = 10;
    return this.postcodeService.search(searchRequest).pipe(
      map(result => result.data),
    );
  }

  selectPostcode(type: TypeaheadMatch) {
    this.postcode = Number(type.item.code);
    this.searchSuburbByPostcode();
  }

  searchSuburbByPostcode() {
    if (this.postcode === null) {
      return;
    }
    this.filterByPostcode = true;
    this.onSearchByPostcode.emit(this.postcode);
  }
}
